import React, { useEffect, useRef, useState } from "react";
import Quill from "quill";
import "quill/dist/quill.snow.css"; // Import Quill's default theme
import { isMobileView } from "./CommonFunctions";
import Icon from "../../assets/icons/Icon";

const QuillEditor = ({ value, onChange, minHeight = "300px", label, infoText,
  tooltipPosition = "bottom",
  tooltipOffset = "0",
  tooltipWidth = null, }) => {

    const [showInfoText,setShowInfoText]=useState(false);
  const editorRef = useRef(null); // Ref for the editor container
  const quillInstanceRef = useRef(null); // Ref to store the Quill instance

  // Initialize Quill editor
  useEffect(() => {
    if (!editorRef.current || quillInstanceRef.current) return;

    // Create Quill instance
    quillInstanceRef.current = new Quill(editorRef.current, {
      theme: "snow", // Use the Snow theme
      modules: {
        toolbar: [
          [{ header: "1" }, { header: "2" }, { font: [] }],
          [{ size: [] }],
          ["bold", "italic", "underline", "strike", "blockquote"],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link", "image", "video"],
          ["clean"],
        ],
      },
    });

    // Listen for changes in the editor
    quillInstanceRef.current.on("text-change", () => {
      const content = quillInstanceRef.current.root.innerHTML; // Get HTML content
      onChange(content); // Pass the content to the parent component

      // Adjust the height dynamically
      const editorElement = editorRef.current;
      editorElement.style.height = "auto"; // Reset height to auto
      editorElement.style.height = `${editorElement.scrollHeight}px`; // Set height to scrollHeight
    });

    // Cleanup on unmount
    return () => {
      if (quillInstanceRef.current) {
        quillInstanceRef.current = null; // Clean up Quill instance
      }
    };
  }, []);

  // Sync the editor's content with the `value` prop
  useEffect(() => {
    if (quillInstanceRef.current && value !== quillInstanceRef.current.root.innerHTML) {
      quillInstanceRef.current.root.innerHTML = value || ""; // Set HTML content

      // Adjust the height dynamically after setting the content
      const editorElement = editorRef.current;
      editorElement.style.height = "auto"; // Reset height to auto
      editorElement.style.height = `${editorElement.scrollHeight}px`; // Set height to scrollHeight
    }
  }, [value]);

  return (
    <div>
      <label
        style={{
          fontFamily: "Inter, Source Sans Pro, Helvetica, Arial, sans-serif",
          marginBottom: "8px", // Apply margin to the label
          display: "block", // Ensure the label is a block element
          fontSize: "14px",
          color: "#000000",
        }}
      >
        {label}
          {infoText && (
            <div className="relative inline-flex group">
              <span onClick={()=>{setShowInfoText(!showInfoText)}} onMouseEnter={()=>{setShowInfoText(true)}} onMouseLeave={()=>{setShowInfoText(false)}} className="inline-flex items-center justify-center ml-1 border border-[rgb(108,113,138)] text-[rgb(108,113,138)] rounded-full w-4 h-4 text-center leading-4 text-xs cursor-pointer">
                i
              </span>
{showInfoText && (
  <div
    className={`
      z-50 px-3 py-2 rounded whitespace-normal
      ${isMobileView()
        ? `fixed left-0 justify-center flex w-full bg-[#4A1E73] text-[#FFFFFF] top-0 }`
        : `
          absolute bg-[#4A1E73] text-[#FFFFFF] 
          ${getTooltipPositionClasses(tooltipPosition)}
          ${tooltipOffset ? `m-${tooltipOffset}` : ""}
        `
      }
    `}
    style={{
      width: isMobileView() ? "100%" : tooltipWidth || undefined,
    }}
  >
    {isMobileView() && (
      <span
        className="absolute top-2 right-2 w-6 h-6 bg-red-500 rounded-full flex items-center justify-center cursor-pointer shadow-lg hover:bg-red-600 transition-colors"
        onClick={(e) => {
          e.stopPropagation();
          setShowInfoText(false);
        }}
        aria-label="Close tooltip"
      >
        <span className="w-4">
          <Icon type="remove" />
        </span>
      </span>
    )}
    {infoText}
  </div>
)}

            </div>
          )}
      </label>
      <div
        className="bg-white"
        ref={editorRef}
        style={{
          minHeight: minHeight,
          width: "full", // Ensure the editor respects the container width
          overflowY: "auto", // Enable vertical scrolling
          overflowX: "hidden", // Prevent horizontal scrolling
          border: "1px solid #d7d5e2", // Border color
          borderRadius: "4px", // Optional: Add border radius for rounded corners
          transition: "border-color 0.2s, box-shadow 0.2s", // Smooth transition for hover
          wordWrap: "break-word", // Ensure text wraps properly
          whiteSpace: "normal", // Allow text wrapping at word boundaries
        }}
        onMouseEnter={() => {
          editorRef.current.style.borderColor = "#408dfb"; // Change border color on hover
          editorRef.current.style.boxShadow = "0 0 0 3px rgba(64, 141, 251, 0.16)"; // Add shadow on hover
        }}
        onMouseLeave={() => {
          editorRef.current.style.borderColor = "#d7d5e2"; // Reset border color on mouse leave
          editorRef.current.style.boxShadow = "none"; // Remove shadow
        }}
      ></div>
    </div>
  );
};
const getTooltipPositionClasses = (position) => {
  switch(position) {
    case 'top': return 'bottom-full left-1/2 -translate-x-1/2 mb-2';
    case 'bottom': return 'top-full left-1/2 -translate-x-1/2 mt-2';
    case 'left': return 'right-full top-1/2 -translate-y-1/2 mr-2';
    case 'right': return 'left-full top-1/2 -translate-y-1/2 ml-2';
    default: return 'bottom-full left-1/2 -translate-x-1/2 mb-2';
  }
};

export default QuillEditor;


// import React, { useEffect, useRef, useState } from "react";
// import Quill from "quill";
// import "quill/dist/quill.snow.css";
// import { isMobileView } from "./CommonFunctions";
// import Icon from "../../assets/icons/Icon";

// const QuillEditor = ({
//   value,
//   onChange,
//   minHeight = "300px",
//   label,
//   infoText,
//   tooltipPosition = "bottom",
//   tooltipOffset = "0",
//   tooltipWidth = null,
//   forceHtmlMode = false,
// }) => {
//   const [showInfoText, setShowInfoText] = useState(false);
//   const [editorMode, setEditorMode] = useState(forceHtmlMode ? "html" : "html");
//   const [htmlContent, setHtmlContent] = useState(value || "");
//   const editorRef = useRef(null);
//   const quillInstanceRef = useRef(null);
//   const textareaRef = useRef(null);
//   const isInitializedRef = useRef(false);

//   // Initialize Quill editor - only once
//   useEffect(() => {
//     if (editorMode !== "visual" || isInitializedRef.current) return;

//     try {
//       // Clear any existing content in the editor container
//       if (editorRef.current) {
//         editorRef.current.innerHTML = '<div class="ql-editor"></div>';
//       }

//       quillInstanceRef.current = new Quill(editorRef.current, {
//         theme: "snow",
//         modules: {
//           toolbar: [
//             [{ header: "1" }, { header: "2" }, { font: [] }],
//             [{ size: [] }],
//             ["bold", "italic", "underline", "strike", "blockquote"],
//             [{ list: "ordered" }, { list: "bullet" }],
//             ["link", "image", "video"],
//             ["clean"],
//           ],
//         },
//       });

//       isInitializedRef.current = true;

//       // Set initial content if exists
//       if (value) {
//         const container = editorRef.current.querySelector(".ql-editor");
//         if (container) {
//           container.innerHTML = value;
//         }
//       }

//       // Handle text changes
//       quillInstanceRef.current.on("text-change", () => {
//         try {
//           if (quillInstanceRef.current) {
//             const content = quillInstanceRef.current.root.innerHTML;
//             setHtmlContent(content);
//             onChange(content);
//           }
//         } catch (error) {
//           console.error("Error handling text change:", error);
//         }
//       });

//     } catch (error) {
//       console.error("Error initializing Quill:", error);
//       setEditorMode("html");
//     }

//     return () => {
//       // Don't destroy Quill instance on cleanup, just remove event listeners
//       if (quillInstanceRef.current) {
//         try {
//           quillInstanceRef.current.off("text-change");
//         } catch (e) {
//           // Ignore cleanup errors
//         }
//       }
//     };
//   }, [editorMode]); // Only depend on editorMode

//   // Update content when value prop changes
//   useEffect(() => {
//     setHtmlContent(value || "");
    
//     if (editorMode === "visual" && quillInstanceRef.current && value !== undefined) {
//       try {
//         const container = editorRef.current.querySelector(".ql-editor");
//         if (container) {
//           // Only update if content is different to avoid cursor jumping
//           if (container.innerHTML !== value) {
//             const selection = quillInstanceRef.current.getSelection();
//             container.innerHTML = value;
            
//             // Restore cursor position if possible
//             if (selection) {
//               setTimeout(() => {
//                 quillInstanceRef.current.setSelection(selection);
//               }, 0);
//             }
//           }
//         }
//       } catch (error) {
//         console.error("Error updating content:", error);
//       }
//     }
//   }, [value, editorMode]);

//   // Sync HTML content to Quill when switching from HTML to Visual mode
//   useEffect(() => {
//     if (editorMode === "visual" && quillInstanceRef.current && isInitializedRef.current) {
//       try {
//         const container = editorRef.current.querySelector(".ql-editor");
//         if (container) {
//           // Update Quill content with current htmlContent
//           const currentHtml = htmlContent || "";
//           if (container.innerHTML !== currentHtml) {
//             container.innerHTML = currentHtml;
//           }
//         }
//       } catch (error) {
//         console.error("Error syncing content on mode switch:", error);
//       }
//     }
//   }, [editorMode, htmlContent]);

//   const handleHtmlChange = (e) => {
//     const newContent = e.target.value;
//     setHtmlContent(newContent);
//     onChange(newContent);
//   };

//   const switchMode = (mode) => {
//     if (mode === editorMode) return;
    
//     // Check if content contains tables
//     const hasTables = htmlContent.includes('<table') || 
//                      htmlContent.includes('<thead') || 
//                      htmlContent.includes('<tbody') ||
//                      htmlContent.includes('<tr>');
    
//     if (mode === "visual" && hasTables) {
//       alert("Tables are not supported in visual mode. Please use HTML mode for table content.");
//       return;
//     }
    
//     setEditorMode(mode);
//   };

//   // Auto-resize textarea
//   useEffect(() => {
//     if (editorMode === "html" && textareaRef.current) {
//       textareaRef.current.style.height = "auto";
//       textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
//     }
//   }, [editorMode, htmlContent]);

 

//   return (
//     <div>
//       <div className="flex justify-between items-center mb-2">
//         <label
//           style={{
//             fontFamily: "Inter, Source Sans Pro, Helvetica, Arial, sans-serif",
//             fontSize: "14px",
//             color: "#000000",
//           }}
//         >
//           {label}
//           {infoText && (
//             <div className="relative inline-flex group">
//               <span
//                 onClick={() => setShowInfoText(!showInfoText)}
//                 onMouseEnter={() => setShowInfoText(true)}
//                 onMouseLeave={() => setShowInfoText(false)}
//                 className="inline-flex items-center justify-center ml-1 border border-[rgb(108,113,138)] text-[rgb(108,113,138)] rounded-full w-4 h-4 text-center leading-4 text-xs cursor-pointer"
//               >
//                 i
//               </span>
//               {showInfoText && (
//                 <div
//                   className={`
//                     z-50 px-3 py-2 rounded whitespace-normal
//                     ${
//                       isMobileView()
//                         ? `fixed left-0 justify-center flex w-full bg-[#4A1E73] text-[#FFFFFF] top-0 }`
//                         : `
//                             absolute bg-[#4A1E73] text-[#FFFFFF] 
//                             ${getTooltipPositionClasses(tooltipPosition)}
//                             ${tooltipOffset ? `m-${tooltipOffset}` : ""}
//                           `
//                     }
//                   `}
//                   style={{
//                     width: isMobileView() ? "100%" : tooltipWidth || undefined,
//                   }}
//                 >
//                   {isMobileView() && (
//                     <span
//                       className="absolute top-2 right-2 w-6 h-6 bg-red-500 rounded-full flex items-center justify-center cursor-pointer shadow-lg hover:bg-red-600 transition-colors"
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         setShowInfoText(false);
//                       }}
//                       aria-label="Close tooltip"
//                     >
//                       <span className="w-4">
//                         <Icon type="remove" />
//                       </span>
//                     </span>
//                   )}
//                   {infoText}
//                 </div>
//               )}
//             </div>
//           )}
//         </label>
        
//         <div className="flex items-center gap-2">
//           <div className="flex border border-gray-300 rounded overflow-hidden">
//             <button
//               type="button"
//               className={`px-3 py-1 text-sm font-medium transition-colors ${
//                 editorMode === "visual"
//                   ? "bg-blue-600 text-white"
//                   : "bg-gray-100 text-gray-700 hover:bg-gray-200"
//               }`}
//               onClick={() => switchMode("visual")}
//               title="Visual Editor"
//             >
//               Visual
//             </button>
//             <button
//               type="button"
//               className={`px-3 py-1 text-sm font-medium transition-colors ${
//                 editorMode === "html"
//                   ? "bg-blue-600 text-white"
//                   : "bg-gray-100 text-gray-700 hover:bg-gray-200"
//               }`}
//               onClick={() => switchMode("html")}
//               title="HTML Editor"
//             >
//               HTML
//             </button>
//           </div>
//         </div>
//       </div>

//       {editorMode === "visual" && (
//         <div
//           ref={editorRef}
//           style={{
//             minHeight: minHeight,
//             width: "100%",
//             border: "1px solid #d7d5e2",
//             borderRadius: "4px",
//           }}
//         ></div>
//       )}

//       {editorMode === "html" && (
//         <textarea
//           ref={textareaRef}
//           value={htmlContent}
//           onChange={handleHtmlChange}
//           className="w-full  bg-white font-mono text-sm p-3 border border-gray-300 rounded"
//           style={{
//             minHeight: minHeight,
//             resize: "vertical",
//           }}
//           onInput={(e) => {
//             e.target.style.height = "auto";
//             e.target.style.height = `${e.target.scrollHeight}px`;
//           }}
//           spellCheck="false"
//           placeholder="Enter HTML content here..."
//         />
//       )}
//     </div>
//   );
// };

// const getTooltipPositionClasses = (position) => {
//   switch (position) {
//     case "top":
//       return "bottom-full left-1/2 -translate-x-1/2 mb-2";
//     case "bottom":
//       return "top-full left-1/2 -translate-x-1/2 mt-2";
//     case "left":
//       return "right-full top-1/2 -translate-y-1/2 mr-2";
//     case "right":
//       return "left-full top-1/2 -translate-y-1/2 ml-2";
//     default:
//       return "bottom-full left-1/2 -translate-x-1/2 mb-2";
//   }
// };

// export default QuillEditor;